export const SMS_CAMPAIGN_TRACKING_TOKEN_STORAGE_PREFIX = 'sms-campaign-tracking-token:';
export const SMS_CAMPAIGN_TRACKING_TOKEN_QUERY_KEY = 'tracking_token';

export function readSmsCampaignTrackingToken(campaignId: string): string {
  const id = campaignId?.trim();
  if (!id) {
    return '';
  }

  try {
    return localStorage.getItem(`${SMS_CAMPAIGN_TRACKING_TOKEN_STORAGE_PREFIX}${id}`)?.trim() || '';
  } catch {
    return '';
  }
}

export function persistSmsCampaignTrackingToken(campaignId: string, trackingToken: string): void {
  const id = campaignId?.trim();
  const token = trackingToken?.trim();
  if (!id || !token) {
    return;
  }

  if (readSmsCampaignTrackingToken(id)) {
    return;
  }

  try {
    localStorage.setItem(`${SMS_CAMPAIGN_TRACKING_TOKEN_STORAGE_PREFIX}${id}`, token);
  } catch {
    // Ignore storage failures (private mode, quota, etc.).
  }
}

export function withoutTrackingTokenQueryParam(
  queryParams: Record<string, string>
): Record<string, string> {
  const { [SMS_CAMPAIGN_TRACKING_TOKEN_QUERY_KEY]: _removed, ...rest } = queryParams;
  return rest;
}
